import React, { FC } from 'react'
import classNames from 'classnames'

import { Pill } from 'sdk/pill/Pill'

import classes from './style.module.scss'

interface ComponentProps {
  className?: string
  pillText?: string
}

export const Divider: FC<ComponentProps> = ({ className, pillText }) => {
  if (pillText) {
    return (
      <div className={classNames(classes.container, className)}>
        <div className={classes.line} />
        <Pill text={pillText} variant='outlineMuted' />
        <div className={classes.line} />
      </div>
    )
  }

  return <hr className={classNames(classes.divider, className)} />
}